import { Button, FormGroup, Grid } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import { DropzoneDialog } from 'material-ui-dropzone'
import React, { useState } from 'react'
import getPayeService from '../../api/envService'
import {
  EXPORT_SYNTHESE_TAGS_ENDPOINT,
  IMPORT_SYNTHESE_TAGS_ENDPOINT,
  IMPORT_SYNTHESE_ZIP_ENDPOINT,
  REFRESH_SYNTHESE_ZIP_ENDPOINT,
} from '../../api/endpoints'
import { useSelector } from 'react-redux'
import { ImportButton } from './ImportButton'

export function ImportSynthese() {
  const testmode = useSelector(state => state.user.testmode)
  const [open, setOpen] = useState(false)
  const handleClick = () => setOpen(true)
  const handleImportTags = files => {
    if (files.length === 1) {
      setOpen(false)
      getPayeService().postFile(IMPORT_SYNTHESE_TAGS_ENDPOINT, files[0], 'dataFile')
    }
  }
  const handleImportZip = files => {
    if (files.length === 1) {
      setOpen(false)
      getPayeService().postFile(IMPORT_SYNTHESE_ZIP_ENDPOINT, files[0], 'dataFile')
    }
  }

  const handleRefreshZip = () => {
    getPayeService().post(REFRESH_SYNTHESE_ZIP_ENDPOINT)
  }

  const handleExport = () => {
    window.open('/' + (testmode ? 'testmode' : 'api') + '/' + EXPORT_SYNTHESE_TAGS_ENDPOINT.endpoint, '_blank')
  }
  return (
    <Grid container style={{ marginTop: 30 }}>
      <Grid item xs={5}>
        <Typography data-test={'Import Synthèses'} variant="h5" style={{ lineHeight: 1.8 }}>
          Import Synthèses
        </Typography>
      </Grid>
      <Grid container xs={6}>
        <Grid container xs={6}>
          <Grid item xs={11}>
            <FormGroup>
              <Button variant="contained" color="primary" onClick={handleClick} data-test="choose-file">
                Importer TAGS
              </Button>
              <DropzoneDialog
                showAlerts={false}
                open={open}
                onSave={handleImportTags}
                dropzoneClass="drop-zone"
                acceptedFiles={['.json', '.JSON']}
                showPreviews={true}
                maxFileSize={5000000}
                onClose={() => setOpen(false)}
                filesLimit={1}
                submitButtonText="Importer"
                cancelButtonText="Annuler"
              />
            </FormGroup>
          </Grid>
        </Grid>
        <Grid container xs={6}>
          <Grid item xs={12}>
            <FormGroup>
              <Button variant="contained" color="primary" onClick={handleExport} data-test="choose-file">
                Export TAGS
              </Button>
            </FormGroup>
          </Grid>
        </Grid>
      </Grid>
      <Grid container xs={12}>
        <Grid xs={5} />
        <Grid xs={6}>
          <ImportButton handleSave={handleImportZip} label="importer un zip" acceptedFiles={['.zip']} />
        </Grid>
      </Grid>
    </Grid>
  )
}
